import { useState, useEffect } from 'react';

export const usePermissions = () => {
  const [permissionMap, setPermissionMap] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadPermissions = () => {
      try {
        const userStr = localStorage.getItem('user');
        if (userStr) {
          const user = JSON.parse(userStr);
          const permMap = user.permissionMap || {};
          console.log('🔑 Loading user permissions:', {
            userId: user.id,
            userName: user.name,
            role: user.role_name,
            permissionCount: Object.keys(permMap).length,
            permissions: permMap
          });
          setPermissionMap(permMap);
        } else {
          console.warn('⚠️ No user data found in localStorage');
        }
      } catch (error) {
        console.error('❌ Error loading permissions:', error);
      } finally {
        setLoading(false);
      }
    };

    loadPermissions();
  }, []);

  const hasPermission = (module, action) => {
    const key = `${module}.${action}`;
    return permissionMap[key] === true;
  };

  const hasAnyPermission = (permissions) => {
    return permissions.some(perm => {
      if (typeof perm === 'string') {
        const [module, action] = perm.split('.');
        return hasPermission(module, action);
      }
      return hasPermission(perm.module, perm.action);
    });
  };

  const hasAllPermissions = (permissions) => {
    return permissions.every(perm => {
      if (typeof perm === 'string') {
        const [module, action] = perm.split('.');
        return hasPermission(module, action);
      }
      return hasPermission(perm.module, perm.action);
    });
  };

  return {
    hasPermission,
    hasAnyPermission,
    hasAllPermissions,
    permissionMap,
    loading
  };
};
